import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import Text from './Text';
import ClassNames from './Text.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { BlockTypes } from '@cvent/carina-rich-text-renderer';
import renderRichText from '../../utils/renderRichText';

/**
 * Data wrapper for the text widget.
 */
export default class TextWidget extends BaseWidget {
  static displayName = 'TextWidget';
  static propTypes = {
    type: PropTypes.string,
    config: PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      baseBlockType: PropTypes.oneOf(Object.values(BlockTypes))
    }),
    classes: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func
  };
  static defaultProps = {
    classes: ClassNames
  };
  getStyleObject() {
    return {
      ...super.getStyleObject(),
      text: this.getElementInlineStyle('textInput')
    };
  }
  render() {
    const { config, translate, classes, style } = this.props;
    const styleObject = this.getStyleObject();
    return (
      <Text
        {...resolveTestId(this.props)}
        classes={classes}
        style={styleObject}
        text={renderRichText(
          config.text,
          translate,
          style.palette,
          styleObject.text,
          { baseBlockType: config.baseBlockType }
        )}
      />
    );
  }
}
